var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"bar completed",style:(`width:${_vm.completedScaled}%`)}),_c('div',{staticClass:"bar waiting",style:(`width:${_vm.remainingScaled}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }